// extracted by mini-css-extract-plugin
export default {"FianzaForm":"FianzaForm_FianzaForm__eZX5L","FianzaLabel":"FianzaForm_FianzaLabel__yLqi4"};